
/* prettier-ignore */

import { Component, computed } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'select-google-lang',
  templateUrl: './select-google-lang.component.html',
  styleUrl: './select-google-lang.component.scss',
})

export class SelectGoogleLanguageComponent {
  selectedLang: string;
  langs: any = [];

  constructor(
    public googleTranslateService: GoogleTranslateService,
    public modalCtrl: ModalController,
    private rest: RestService
  ) {

    const localLangs = this.rest?.device?.languages || [];
    console.log("LocalLangs: ", localLangs)
    this.langs = this.googleTranslateService.availableLangs?.filter(e => !localLangs.includes(e.code));
  }

  changeLang(){
    this.googleTranslateService.setLang(this.selectedLang)
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}